// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jh-1";
export var messageSideRight = "_jh-2";
export var orderLookupBubbleContainer = "_jh-0";
export var submitButton = "_jh-3";